import React from 'react';

const SidenavDivider = (props) => {
  const { className, ...rest } = props;
  return (
    <div className={`sidenav-divider ${className || ''}`} {...rest} />
  );
};
export default SidenavDivider;
